<template lang="html">
  <div>

    <slot></slot>

  </div>
</template>

<script>
export default {
  name: 'visc-layout',
}
</script>

<style>
.st0{fill:#1db577;}
</style>
